import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getAccountId, getToken } from '../token';
import * as pbi from 'powerbi-client';
import Typography from '@material-ui/core/Typography';
import { Redirect } from 'react-router-dom';
import {
  showNotification
} from 'react-admin';
import { connect } from 'react-redux';
import { externalRedirect } from '../../src/utils';

const models = pbi.models;

const styles = {
  report: {
    height: '80%',
    width: '99%',
    position: 'absolute',
    margin: '0 10px',
    '& iframe': {
      border: 'none'
    },
  },
  noDashboardMessage: {
    maxWidth: '600px',
    margin: '100px auto',
    textAlign: 'center',
  },
  card: {
    boxShadow: '0 2px 5px 0 rgba(0,0,0,0.26), 0 2px 10px 0 rgba(0,0,0,0.16)',
    borderRadius: '0',
    '&& div': {
      padding: '0',
    }
  },
  header: {
    lineHeight: '64px',
    paddingLeft: '24px',
  },
  progressBar: {
    flex: '1',
    alignSelf: 'center',
  },
};

class Report extends Component {
  constructor () {
    super();
    this.state = {
      type: 'report',
      tokenType: models.TokenType.Embed,
      accessToken: '',
      embedUrl: '',
      id: '',
      permissions: models.Permissions.View,
      loading: true,
      isDashboardAvailable: false,
      shouldShowDashborad: getAccountId() < 14800,
    };
  }

  componentDidMount () {
    if(this.state.shouldShowDashborad){
      this.renderPowerBiReport();
    }
  };

  renderPowerBiReport = () => {
    this.powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    this.getData().then(response => {
      this.setState({accessToken: response.token});
      this.setState({embedUrl: this.getReportUrl(response.report_id, response.group_id)});
      this.setState({id: response.report_id});
      let reportContainer = document.getElementById('reportContainer');
      this.powerbi.embed(reportContainer, this.state);
    }).catch(function (err) {
        console.error(`Compliance Dashboard loading failed. Following error occured: ${err}`);
    });
  };

  getTokenUrl = () => {
    return `${process.env.REACT_APP_API_COMPLIANCEDASHBOARD_TOKEN}/${getAccountId()}`;
  };

  getReportUrl = (report_id, group_id) => {
    return `https://app.powerbi.com/reportEmbed?reportId=${report_id}&groupId=${group_id}`;
  };

  getData = () => {
    return fetch(this.getTokenUrl(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
    }).then(response => {
        this.setState({loading: false});
        if (response.status < 200 || response.status >= 300) {
          return <Redirect to={`/login`}/>;
        } else {
          this.setState({isDashboardAvailable: true});
          return response.json();
        }
      }).catch(function (err) {
        console.error(err);
      });
  };

  render () {
    externalRedirect('compliance-dashboard');
    const {classes} = this.props;

    if(!this.state.shouldShowDashborad){
      return (
        <div>
          <Card className={classes.card}>
            <CardContent>
              <div className={classes.report} id="reportContainer"></div>
            </CardContent>
          </Card> :
          <Typography variant="h5" className={classes.noDashboardMessage}>Because of technical issues the Compliance Dashboard is currently not available to some users, we’re working on solving the problem. Please contact Customer Support if you have any questions.</Typography>
        </div>
      )
    }

    return (
      <div>

        {this.state.loading ? <CircularProgress className={classes.progressBar}
                                                  variant="indeterminate"/> : this.state.isDashboardAvailable ?
          <Card className={classes.card}>
            <CardContent>
              <div className={classes.report} id="reportContainer"></div>
            </CardContent>
          </Card> :
          <Typography variant="h5" className={classes.noDashboardMessage}>Your Compliance Dashboard is
            being generated, this can take up to 48 hours since your
            account was created. Please feel free to contact us by using the form in the lower right
            corner.</Typography>
        }
      </div>

    );
  }
}

const styledReport = withStyles(styles)(Report);

export default connect(null, {
  showNotification,
})(styledReport);
